import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import {
	ICopyWordFromDictionaryPayload,
	ICrosswordBookWordEntity,
} from '../../Api/CrosswordBook';

export type TCopyWordFromDictionaryUseCase = {
	execute(data: ICopyWordFromDictionaryPayload): Promise<ICrosswordBookWordEntity[]>;
};

export const CopyWordFromDictionaryUseCase = (): TCopyWordFromDictionaryUseCase => {
	const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

	return {
		async execute(data) {
			const result = await CrosswordBookRepository.copyFromDictionary(data);

			return result;
		},
	};
};
